module.exports = __webpack_public_path__ + "img/new_index_cases20.f5e5cc03.png";